import { PinterestShareData, TwitterShareData, ShareData } from 'web-core-src';
import { IDomainConstants, IShareSite, ISupportSite } from './website-constants.interfaces';

//#region ShareSites

export class FacebookConstants implements IDomainConstants, IShareSite {
    public FULL_MAIN_DOMAIN_URL: string = 'https://www.facebook.com';
    public MAIN_DOMAIN: string = 'facebook.com';
    public NAME: string = 'facebook';

    public getShareUrl(data: ShareData): string {
        let res: string = new URL('sharer/sharer.php?u=' + data.url, this.FULL_MAIN_DOMAIN_URL).toString();
        return res;
    }
}

export class LinkedInConstants implements IDomainConstants, IShareSite {
    public FULL_MAIN_DOMAIN_URL: string = 'https://www.linkedin.com';
    public MAIN_DOMAIN: string = 'linkedin.com';
    public NAME: string = 'linkedin';

    public getShareUrl(data: ShareData): string {
        let res: string = new URL('shareArticle?mini=true&url=' + data.url, this.FULL_MAIN_DOMAIN_URL).toString();
        return res;
    }
}

export class PinterestConstants implements IDomainConstants, IShareSite {
    public FULL_MAIN_DOMAIN_URL: string = 'https://www.pinterest.com';
    public MAIN_DOMAIN: string = 'pinterest.com';
    public NAME: string = 'pinterest';

    public getShareUrl(data: PinterestShareData): string {
        let res: string = new URL(
            'pin/create/bookmarklet/?media=' + data.media + '&url=' + data.url + '&description=' + data.title,
            this.FULL_MAIN_DOMAIN_URL
        ).toString();
        return res;
    }
}

export class RedditConstants implements IDomainConstants, IShareSite {
    public FULL_MAIN_DOMAIN_URL: string = 'https://www.reddit.com';
    public MAIN_DOMAIN: string = 'reddit.com';
    public NAME: string = 'reddit';

    public getShareUrl(data: ShareData): string {
        let res: string = new URL(
            'submit?url=' + data.url + '&title=' + data.title,
            this.FULL_MAIN_DOMAIN_URL
        ).toString();
        return res;
    }
}

export class TwitterConstants implements IDomainConstants, IShareSite {
    public FULL_MAIN_DOMAIN_URL: string = 'https://twitter.com';
    public MAIN_DOMAIN: string = 'twitter.com';
    public NAME: string = 'twitter';

    public RICH_TEXT_EDITOR: string = '.rich-editor';

    public getShareUrl(data: TwitterShareData): string {
        let res: string = new URL(
            'share?url=' + data.url + '&text=' + data.title,
            this.FULL_MAIN_DOMAIN_URL
        ).toString();
        if (data.hashtags) {
            res += '&hashtags=' + data.hashtags;
        }
        if (data.via) {
            res += '&via=' + data.via;
        }
        return res;
    }
}

//#endregion

//#region SupportSite

export class PatreonConstants implements IDomainConstants, ISupportSite {
    public FULL_MAIN_DOMAIN_URL: string = 'https://www.patreon.com';
    public MAIN_DOMAIN: string = 'patreon.com';
    public NAME: string = 'patreon';

    public getSupportUrl(userName: string): string {
        return new URL(userName, this.FULL_MAIN_DOMAIN_URL).toString();
    }
}

export class KofiConstants implements IDomainConstants, ISupportSite {
    public FULL_MAIN_DOMAIN_URL: string = 'https://ko-fi.com';
    public MAIN_DOMAIN: string = 'ko-fi.com';
    public NAME: string = 'ko-fi';

    public getSupportUrl(userName: string): string {
        return new URL(userName, this.FULL_MAIN_DOMAIN_URL).toString();
    }
}

//#endregion

//#region Others

export class GoogleConstants implements IDomainConstants {
    public FULL_MAIN_DOMAIN_URL: string = 'https://www.google.com';
    public MAIN_DOMAIN: string = 'google.com';
    public NAME: string = 'google';
}

export class YoutubeConstants implements IDomainConstants {
    public FULL_MAIN_DOMAIN_URL: string = 'https://www.youtube.com';
    public MAIN_DOMAIN: string = 'youtube.com';
    public NAME: string = 'youtube';
}

//#endregion

//#region Main domain and application website

export class DeveloperCompanyWebsiteConstants implements IDomainConstants {
    public FULL_MAIN_DOMAIN_URL: string = 'https://@developerCompanyWebsiteDomain';
    public MAIN_DOMAIN: string = '@developerCompanyWebsiteDomain';
    public NAME: string = 'wecdev';
}

export class ApplicationWebsiteConstants implements IDomainConstants {
    public FULL_MAIN_DOMAIN_URL: string = 'https://@applicationWebsiteDomain';
    public MAIN_DOMAIN: string = '@applicationWebsiteDomain';
    public NAME: string = 'application_website';
    //if any error happens before application nam is set, we use this to display error messages
    public NAME_SNAKE_CASE: string = '@applicationShortNameSnakeCase';
}

//#endregion
